import { getOperationsForSelectorMenu } from 'modules/transactions/api/getOperationsForSelectorMenu';
import { useCallback, useEffect, useState } from 'react';
import { Operation } from 'types';

type OperationsResponse = {
  data: Partial<Operation>[];
  pagination: {
    items: number;
    page: number;
    totalItems: number;
    totalPages: number;
  };
};

export const useGetDocumentsSelectorOperations = (societyId: string) => {
  const [data, setData] = useState<Partial<Operation>[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchOperations = useCallback(async () => {
    if (!societyId) return;

    setIsLoading(true);
    setIsError(false);

    try {
      const operations = (await getOperationsForSelectorMenu(
        societyId
      )) as OperationsResponse;

      setData(operations?.data || []);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [societyId]);

  useEffect(() => {
    fetchOperations();
  }, [fetchOperations]);

  return {
    data,
    isLoading,
    isError,
  };
};
